import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';
import { CLIENT_LABELS } from '@epics/clientManagement/constants/labels';

export type ClientStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getClientStatusDialogConfig(
  clientName: string,
  isActive: boolean
): ClientStatusDialogConfig {
  const isActivating = !isActive;

  return {
    title: isActivating
      ? CLIENT_LABELS.STATUS_DIALOG_ACTIVATE_TITLE
      : CLIENT_LABELS.STATUS_DIALOG_DEACTIVATE_TITLE,
    content: isActivating ? (
      <>
        <span>{CLIENT_LABELS.STATUS_DIALOG_ACTIVATE_PREFIX}</span>
        <span className="font-medium">{clientName}</span>
        <span>{CLIENT_LABELS.STATUS_DIALOG_ACTIVATE_SUFFIX}</span>
      </>
    ) : (
      <>
        <span>{CLIENT_LABELS.STATUS_DIALOG_DEACTIVATE_PREFIX}</span>
        <span className="font-medium">{clientName}</span>
        <span>{CLIENT_LABELS.STATUS_DIALOG_DEACTIVATE_SUFFIX}</span>
      </>
    ),
    confirmButtonLabel: isActivating
      ? CLIENT_LABELS.STATUS_DIALOG_CONFIRM_ACTIVATE
      : CLIENT_LABELS.STATUS_DIALOG_CONFIRM_DEACTIVATE,
    confirmButtonLabelLoading: isActivating
      ? CLIENT_LABELS.STATUS_DIALOG_CONFIRM_ACTIVATING
      : CLIENT_LABELS.STATUS_DIALOG_CONFIRM_DEACTIVATING,
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
